import type { ReactNode } from "react";

export default function SectionHeader({
  step,
  title,
  description,
  rightSlot,
}: {
  step?: string;
  title: string;
  description?: string;
  rightSlot?: ReactNode;
}) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        {step ? (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-50 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-brand-700 ring-1 ring-brand-100">
            Step {step}
          </span>
        ) : null}
        <h2 className="mt-2 font-display text-3xl text-ink-800 sm:text-4xl">
          {title}
        </h2>
        {description ? (
          <p className="mt-3 max-w-2xl text-base text-ink-500 sm:text-lg">
            {description}
          </p>
        ) : null}
      </div>
      {rightSlot ? <div>{rightSlot}</div> : null}
    </div>
  );
}
